export default "__VITE_ASSET__BH_D579m__$_?inline__"